import React, { Component } from "react";

import settings from "../settings.js";
import { Link } from "react-router-dom";

import Crown from "../assets/crown.svg";
import Scrollbars from "react-custom-scrollbars";

class Ads extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true, ads: [] };
  }
  componentDidMount() {
    this.loadData();
  }
  loadData() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url + "get_ads/" + window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ ads: response, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }
  clickAd(e, ad) {
    e.preventDefault();
    fetch(
      settings.server_url +
        "set_ad_click/" +
        window.sessionStorage.getItem("sid") +
        "/" +
        ad.padv_id
    )
      .then((res) => res.json())
      .then((response) => {
        window.location = ad.padv_url;
      })
      .catch((error) => console.error("Error:", error));
  }

  render() {
    // Always show 3 ads, fill with empty blocks if needed
    const adsToShow = 3;
    const ads = this.state.ads || [];

    return Array.from({ length: adsToShow }, (_, index) => {
      const ad = ads[index];

      return (
        <div key={index} className="gridItem">
          <div className="gridHeader">
            <div className="gridHeaderTitle">Advertentie</div>
            <div className="gridHeaderAll"></div>
          </div>

          {ad ? (
            <div className="ad">
              <div
                className="content-block h-100"
                style={{ borderRadius: "0 0 12px 12px" }}
              >
                <a href={"/#"} onClick={(e) => this.clickAd(e, ad)}>
                  <img
                    src={"https://kv.valkweb.nl" + ad.padv_image}
                    alt=""
                    width="100%"
                    style={{ borderRadius: "0 0 12px 12px" }}
                  />
                </a>
              </div>
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "10px" }}>
              Geen advertentie
            </div>
          )}
        </div>
      );
    });
  }
}

export default Ads;
